var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "card" },
    [
      _c(
        "v-icon",
        { attrs: { color: "primary", disabled: !_vm.editing, small: "" } },
        [_vm._v("edit")]
      ),
      _c("v-text-field", {
        attrs: {
          type: "text",
          label: "Razón Social",
          name: "nombre",
          value: _vm.cliente.nombre
        },
        on: { input: _vm.handleName }
      }),
      _c(
        "v-icon",
        { attrs: { color: "primary", disabled: !_vm.editing, small: "" } },
        [_vm._v("edit")]
      ),
      _c("v-text-field", {
        attrs: {
          type: "text",
          label: "RUT",
          value: _vm.cliente.rut.split("-")[0]
        },
        on: { input: _vm.handleRut }
      }),
      _c(
        "v-icon",
        { attrs: { color: "primary", disabled: !_vm.editing, small: "" } },
        [_vm._v("edit")]
      ),
      _c("v-text-field", {
        attrs: { type: "text", label: "Estado", value: _vm.cliente.estado },
        on: { input: _vm.handleEstado }
      }),
      _c(
        "v-icon",
        { attrs: { color: "primary", disabled: !_vm.editing, small: "" } },
        [_vm._v("edit")]
      ),
      _c("v-text-field", {
        attrs: { type: "text", label: "Giro", value: _vm.cliente.giro },
        on: { input: _vm.handleGiro }
      }),
      _c("v-text-field", {
        staticStyle: { cursor: "no-drop" },
        attrs: {
          type: "text",
          label: "ID",
          value: _vm.cliente.id,
          readonly: "",
          disabled: ""
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }